'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const LEVELS = {
    DEBUG: 'debug',
    INFO: 'info',
    WARNING: 'warn',
    ERROR: 'error',
};
const LEVEL_LABELS = {
    [LEVELS.DEBUG]: 'debug',
    [LEVELS.INFO]: 'info',
    [LEVELS.WARNING]: 'warn',
    [LEVELS.ERROR]: 'error',
};
const LEVEL_COLORS = {
    [LEVELS.DEBUG]: '#00CCFF',
    [LEVELS.INFO]: '#6600CC',
    [LEVELS.WARNING]: '#FF9933',
    [LEVELS.ERROR]: '#CC3333',
};
const DEFAULT_CONTEXT = 'app';
/**
 * Fast and simple dev logger
 * @description Logs visible only in development environment
 * @class
 * @example
 * ```ts
 * const logger = new Logger('test')
 * logger.debug('Test message', { a: 'b', b: 'a' })
 * ```
 */
class Logger {
    context;
    /**
     * @param context Logger context
     */
    constructor(context = DEFAULT_CONTEXT) {
        this.context = context;
    }
    /**
     * Print log message to console
     * @param level Log level
     * @param message Text message
     * @param [meta] Additional data
     */
    log(level, message, meta) {
        if (process.env.NODE_ENV === 'development') {
            const label = this.context;
            const color = LEVEL_COLORS[level];
            const labelStyle = `font-weight: bold; color: ${color}`;
            const ctxStyle = 'font-weight: bold; color: #CC00FF';
            const msgStyle = 'font-weight: normal;';
            const time = new Date().toLocaleTimeString();
            if (typeof message === 'object') {
                console.log(`%c${time} %c[${LEVEL_LABELS[level]}] %c${label} `, msgStyle, labelStyle, ctxStyle, message);
            }
            else if (typeof meta !== 'undefined') {
                console.groupCollapsed(`%c${time} %c[${LEVEL_LABELS[level]}] %c${label} %c${message}`, msgStyle, labelStyle, ctxStyle, msgStyle);
                console.log(meta);
                console.groupEnd();
            }
            else {
                console.log(`%c${time} %c[${LEVEL_LABELS[level]}] %c${label} %c${message}`, msgStyle, labelStyle, ctxStyle, msgStyle);
            }
        }
    }
    /**
     * Print log with debug level
     * @param message Text message
     * @param meta Additional data
     */
    debug(message, meta) {
        this.log(LEVELS.DEBUG, message, meta);
    }
    /**
     * Print log with info level
     * @param message Text message
     * @param meta Additional data
     */
    info(message, meta) {
        this.log(LEVELS.INFO, message, meta);
    }
    /**
     * Print log with warning level
     * @param message Text message
     * @param meta Additional data
     */
    warn(message, meta) {
        this.log(LEVELS.WARNING, message, meta);
    }
    /**
     * Print log with error level
     * @param message Text message
     * @param meta Additional data
     */
    error(message, meta) {
        this.log(LEVELS.ERROR, message, meta);
    }
}

exports.default = Logger;
//# sourceMappingURL=logger.js.map
